import React from "react";

export default ({ name, spin = false, className = "", ...props }) => (
  <i
    aria-hidden="true"
    className={`fa ${spin ? "fa-spin" : ""} fa-${name} ${className}`}
    {...props}
  ></i>
);
